import ProposalHelper from './proposal_helper';
import FinancingHelper from './financing_helper';

import Constants from './constants';

export default class StoreHelper {
  static getFinancingProductCreditResult({ currentProductTabType, eligibility }) {
    if (!eligibility || !eligibility.creditCheck || !eligibility.creditCheck.financingProducts) return null;
    return (
      eligibility.creditCheck.financingProducts.find(
        ({ financingProductType }) => financingProductType === currentProductTabType
      ) || null
    );
  }

  static getCreditCheckForCurrentFinancingMethod({ proposal, financingMethod, eligibility, view }) {
    const currentFinancingMethod = this.getFinancingMethodToFetch({ proposal, financingMethod, view });
    const currentProductSku = FinancingHelper.getProductSku(currentFinancingMethod);

    return (
      eligibility?.creditCheck?.financingProducts?.find(
        ({ financingProductSku }) => financingProductSku === currentProductSku
      ) || null
    );
  }

  static getRateCards({ currentProductTabType, eligibility }) {
    const financingProductResult = this.getFinancingProductCreditResult({ currentProductTabType, eligibility });
    if (!financingProductResult) return [];
    return financingProductResult.rateCards;
  }

  static filterRateCardsByTermApr({ rateCards, term, apr }) {
    const termFilter = term;
    const aprFilter = apr;
    /* eslint-disable no-shadow */
    return (rateCards && rateCards.find(({ term, apr }) => term === termFilter && apr === aprFilter)) || null;
    /* eslint-enable no-shadow */
  }

  static getMaxLoanAmountByProduct({ eligibility, proposal }, product) {
    if (eligibility === null) return null;
    const lightFinancingMethods = proposal.financingMethods;
    let term, apr, currentProductTabType;

    lightFinancingMethods.forEach((financingMethod) => {
      if (product.financingProductSku === financingMethod.productSku) {
        term = financingMethod.term;
        apr = financingMethod.apr;
        currentProductTabType = financingMethod.productType;
      }
    });

    const rateCards = this.getRateCards({ currentProductTabType, eligibility });
    if (!rateCards || !rateCards.length) return null;

    if (
      currentProductTabType === Constants.PRODUCT_TYPE_EE_LOAN ||
      currentProductTabType === Constants.PRODUCT_TYPE_LOAN
    ) {
      return (rateCards[0] && Math.round(rateCards[0].maxLoanAmount)) || null;
    }

    const rateCard = this.filterRateCardsByTermApr({ rateCards, term, apr });
    return (rateCard && Math.round(rateCard.maxLoanAmount)) || null;
  }

  static getMaxProjectCostByProduct({ financingMethods, product }) {
    let maxProjectCost = null;
    Object.keys(financingMethods).forEach((id) => {
      let financingMethod = financingMethods[id];
      if (financingMethod.financingProduct && product.financingProductId === financingMethod.financingProduct.id) {
        maxProjectCost = financingMethod.calculations.maxProjectCost;
      }
    });

    return maxProjectCost;
  }

  static getStips({ currentProductTabType, eligibility }) {
    if (!eligibility || !eligibility.creditCheck || !eligibility.creditCheck.financingProducts) return [];

    const financingProductCreditResult = this.getFinancingProductCreditResult({ currentProductTabType, eligibility });
    if (!financingProductCreditResult || !financingProductCreditResult.rateCards) return [];

    let allStips = financingProductCreditResult.rateCards.reduce((collectedStips, rateCard) => {
      return collectedStips.concat(rateCard.stips);
    }, []);

    if (!allStips || !allStips.length) return [];

    let stipCodesUsed = [];
    return allStips.reduce((dedupedStips, stip) => {
      if (stipCodesUsed.indexOf(stip.reqId) < 0) {
        dedupedStips.push(stip);
        stipCodesUsed.push(stip.reqId);
      }
      return dedupedStips;
    }, []);
  }

  static getFinancingMethodToFetch({ proposal, financingMethod, view }) {
    return financingMethod ? financingMethod : ProposalHelper.determineFinancingMethodToFetch(proposal, view);
  }

  static isStipAccepted(stipStatusNotes) {
    if (!stipStatusNotes.length) return false;

    return stipStatusNotes.some((note) => note.decision === Constants.STIP_STATUS_ACCEPTED);
  }

  static findStepDocsInEnvelope(financingRequest, stepId, envelopeId) {
    return financingRequest.steps
      .find((step) => step.id === stepId)
      .docs.filter(({ currentRevision }) => currentRevision !== null)
      .filter(({ currentRevision }) => currentRevision.currentEnvelopeId === envelopeId);
  }

  static findStepDocs(financingRequest, filterFnc) {
    let docs = financingRequest.steps.reduce((acc, step) => {
      step.docs.forEach((doc) => acc.push(doc));
      return acc;
    }, []);

    if (typeof filterFnc === 'function') {
      return docs.filter(filterFnc);
    }
    return docs;
  }

  static findCurrentUnapprovedStep(financingRequest) {
    const { currentUnapprovedStepId } = financingRequest;
    if (currentUnapprovedStepId === null) return null;
    return financingRequest.steps.find((step) => step.id === currentUnapprovedStepId);
  }
}
